import { z } from 'zod';

export enum Environment {
    Development = 'development',
    Production = 'production',
}

export const ConfigSchema = z.object({
    mode: z.nativeEnum(Environment).default(Environment.Development),
    port: z.coerce.number().int().positive().default(3000),
    apiUrl: z.url(),
    requestTimeout: z.coerce.number().nonnegative().default(10000),
    storage: z.string().min(1),
    bucket: z.string().min(1)
});

export type ConfigT = z.infer<typeof ConfigSchema>;